import React, { useMemo } from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchItemList,
  DemoWorkbenchPill,
} from "@csk/demo-ui";
import {
  explainReceipt,
  type Receipt,
} from "./receipt-explainer-panel/receiptExplanationModel.js";

export function ReceiptExplainerPanel(props: {
  receipt: Receipt | null;
}): React.JSX.Element {
  const lines = useMemo(
    () => (props.receipt ? explainReceipt(props.receipt) : []),
    [props.receipt],
  );
  return (
    <DemoWorkbenchCard
      title="Explain a receipt"
      right={<DemoWorkbenchPill>UI-only</DemoWorkbenchPill>}
      compact
    >
      {!props.receipt ? (
        <DemoWorkbenchCopy>
          Paste a receipt JSON into the “receipt.json” file under{" "}
          <code>ui/public/data</code> to view it here.
        </DemoWorkbenchCopy>
      ) : (
        <DemoWorkbenchItemList
          items={lines.map((line) => ({
            id: line,
            label: line,
          }))}
        />
      )}
    </DemoWorkbenchCard>
  );
}
